import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import type { CommerceProduct } from '../../api/areas/commerce';
import { DomainLink } from '../../components/Ids';
import { cellLink, Label } from './shared';

export function productName(item: CommerceProduct): string {
  return item.product_kind === 'SERVICE' ? item.description || item.plan_code : item.domain_name;
}

/** A sold service links to its subscription, even when its label happens to be a domain name. */
export function ProductItem({ item }: { item: CommerceProduct & { domain_id?: string | null; subscription_id?: string | null } }) {
  if (item.product_kind === 'DOMAIN') return item.domain_id ? <DomainLink keyOrName={item.domain_id} label={item.domain_name} /> : <span className="font-medium">{item.domain_name}</span>;
  return <>
    {item.subscription_id ? <Link className={cellLink} to={`/sales?tab=subscriptions&service=${encodeURIComponent(item.subscription_id)}`}>{productName(item)}</Link> : <span className="font-medium">{productName(item)}</span>}
    <span className="block text-xs text-muted-foreground">{item.plan_code}</span>
  </>;
}

export function ProductOperation({ item, longYears = false }: { item: CommerceProduct; longYears?: boolean }) {
  const { t } = useTranslation('commerce');
  const { t: ts } = useTranslation('subscriptions');
  if (item.product_kind === 'SERVICE') return <><Label group="serviceAction" value={item.action} /> · {ts(`cycle.${item.cycle}`)}</>;
  return <><Label group="operation" value={item.operation} /> · {t(longYears ? 'common.yearsLong' : 'common.years', { count: item.years })}</>;
}
